import { initializeConnector } from '@web3-react/core'
import { MetaMask } from '@web3-react/metamask'
import { WalletConnect } from '@web3-react/walletconnect-v2'

const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT
const PROJECT_ID = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || ''

// Polygon mainnet 137, Mumbai 80001
const CHAIN_IDS = ENVIRONMENT === 'development' ? [80001] : [137]

export const [metaMask, metaMaskHooks] = initializeConnector((actions) => new MetaMask({ actions }))

export const [walletConnect, walletConnectHooks] = initializeConnector(
  (actions) =>
    new WalletConnect({
      actions,
      options: {
        projectId: PROJECT_ID,
        chains: CHAIN_IDS,
        optionalChains: CHAIN_IDS,
        showQrModal: true
      }
    })
)

export const connectors = [
  [metaMask, metaMaskHooks],
  [walletConnect, walletConnectHooks]
]